import { render, staticRenderFns } from "./AddAdditionalVisitorsSocial.vue?vue&type=template&id=27bb1854&scoped=true&"
import script from "./AddAdditionalVisitorsSocial.vue?vue&type=script&lang=js&"
export * from "./AddAdditionalVisitorsSocial.vue?vue&type=script&lang=js&"
import style0 from "./AddAdditionalVisitorsSocial.vue?vue&type=style&index=0&id=27bb1854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb1854",
  null
  
)

export default component.exports